/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { CustomAppState } from "@eisinc/App/Store/Reducers";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useEffect } from "react";
import React from "react";
import { connect } from "react-redux";

const headerOffset = 75;
const headerOffSetMobile = 120;
const cookieOffsetMobile = 50;

const mapStateToProps = (state: CustomAppState) => ({
    location: getLocation(state),
    anchorLinksTimeout: (getSettingsCollection(state).customSettings as any)?.anchorLinksTimeout,
    isMobileScreen: state.xCommon.isMobileScreen,
    globalMessage: state.xHeader.globalMessage,
});

export interface ScrollToAnchorProps {}

interface Props extends ScrollToAnchorProps, ReturnType<typeof mapStateToProps> {}

const ScrollToAnchor: React.FC<Props> = ({ location, anchorLinksTimeout, isMobileScreen, globalMessage }) => {
    const getHeaderOffset = () => {
        if (isMobileScreen) {
            return globalMessage ? headerOffSetMobile + cookieOffsetMobile : headerOffSetMobile;
        }

        return headerOffset;
    };

    const scrollToElement = () => {
        if (location.hash) {
            const targetId = location.hash.slice(1);
            const element = document.getElementById(targetId);

            if (element) {
                const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - getHeaderOffset();

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    };

    useEffect(() => {
        const timer = setTimeout(scrollToElement, anchorLinksTimeout || 200);
        return () => clearTimeout(timer);
    }, [location.hash]);

    useEffect(() => {
        const timer = setTimeout(scrollToElement, anchorLinksTimeout || 200);
        return () => clearTimeout(timer);
    }, []); // Trigger on initial render

    return null;
};

export default connect(mapStateToProps)(ScrollToAnchor);
